module.exports = __webpack_public_path__ + "img/c17657c.png";